export default [
  {
    title: 'Suivi des commandes',
    icon: 'PackageIcon',
    route: 'support-order-tracking',
  },
  {
    title: 'Tickets de support',
    icon: 'HelpCircleIcon',
    route: 'SupportTicketList',
  },
  {
    title: 'Réclamations Livreur',
    icon: 'TruckIcon',
    route: 'support-driver-ticket-list',
    meta: { requiresAdmin: false },
  },
  {
    title: 'Demandes de nouvelle livraison',
    icon: 'TruckIcon',
    route: 'RedeliveryRequestList',
    meta: { requiresAdmin: true },
  },
  {
    title: 'Demandes de modification de prix',
    icon: 'DollarSignIcon',
    route: 'PriceChangeRequestList',
    meta: { requiresAdmin: true },
  },
  {
    title: 'Nouveau traitement anomalie',
    icon: 'CornerUpLeftIcon',
    route: 'bon-retour-definitive-add',
  },
  {
    title: 'Liste traitement anomalie',
    icon: 'ListIcon',
    route: 'bon-retour-definitive-list',
  },
]
